/**
 * Event calendar component
 * 
 * @module event-calendar
 * @version 1.0.0
 * @extends HTMLElement
 */

if (!customElements.get('event-calendar')) {

    class eventCalendar extends HTMLElement {
  
        constructor() {
          super();
  
          this.initEvents();
        }
  
      /**
       * Init events
       * 
       * @returns {undefined}
       */
  
      initEvents() {
        const title = this.dataset.title;
        const endDate = this.dataset.endDate + "T23:59:00Z";
        const startDate = this.dataset.startDate + "T00:01:00Z";
        const local = this.dataset.local;
        const description = this.dataset.description;

        const formatDescription = encodeURIComponent(description);

        const formatEndDate =  endDate.replace(/[-:]/g, "");
        const formatStartDate = startDate.replace(/[-:]/g, "");

        const isIphone = /iPhone/i.test(navigator.userAgent);
        const isNotSafari = /CriOS/i.test(navigator.userAgent);

        const google = this.querySelector("[data-google-calendar]");
        const googleiCal = this.querySelector("[data-google-calendar-ical]");
        const iPhone = this.querySelector("[data-iphone-calendar]");

        if (isIphone && !isNotSafari) {
            google.classList.add("hidden");
            googleiCal.classList.remove("hidden");
        } else if (isIphone) {
            google.classList.remove("hidden");
            googleiCal.classList.add("hidden");

            this.addGoogleEventLink(title, formatStartDate, formatEndDate, local, formatDescription, description);
            this.addOutlookEventLink(title, startDate, endDate, local, description);

            iPhone.classList.add("hidden");
        } else {
            google.classList.remove("hidden");
            googleiCal.classList.add("hidden");
        }

    }

    addGoogleEventLink(title, startDate, endDate, local, formatDescription, description) {
        const googleElement = this.querySelector("[data-google-link]");

            let url = "https://calendar.google.com/calendar/render?action=TEMPLATE";
            let parametros = [
                "text=" + encodeURIComponent(title),
                "dates=" + encodeURIComponent(endDate) + "/" + encodeURIComponent(startDate),
                "location=" + encodeURIComponent(local),
                "details=" + formatDescription
            ];

            let link = url + "&" + parametros.join("&");

            googleElement.href  = link + "&trp=false&sprop=&sprop=name:";
        
    }

    addOutlookEventLink(title, startDate, endDate, local, description) {
        let link = "https://outlook.office.com/calendar/0/deeplink/compose?subject=" + encodeURIComponent(title) + "&body=" + description + "&startdt=" + encodeURIComponent(startDate) + "&enddt=" + encodeURIComponent(endDate) + "&location=" + encodeURIComponent(local) + "&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent";
        let outlookElement = this.querySelector("[data-outlook-calendar]");

        outlookElement.href  = link;
    }

    addYahooEventLink(title, startDate, endDate, local, description) {
        let link = "https://calendar.yahoo.com/?v=60&view=d&type=20&title=" + encodeURIComponent(title) + "&st=" + encodeURIComponent(startDate) + "&et=" + encodeURIComponent(endDate) + "&desc=" + description + "&in_loc=" + encodeURIComponent(local);
        let yahooElement = this.querySelector("[data-yahoo-calendar]");

        yahooElement.href  = link;
    }

    downloadICS(title, startDate, endDate, local, description)  {

        let icsData =
`BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//My Company//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
DTSTART:${startDate}
DTEND:${endDate}
SUMMARY:${title}
LOCATION:${local}
DESCRIPTION:${description}
END:VEVENT
END:VCALENDAR`;
                      
        let blob = new Blob([icsData], { type: 'text/calendar;charset=utf-8' });

        saveAs(blob, 'event.ics');
          
    }


}

customElements.define('event-calendar', eventCalendar);

}
